import React, { useRef } from 'react';
import _map from 'lodash/map';
import SelectOptionFlexible from 'styles/blocks/selectOption/flexible';
import { useAutoFocus } from 'common/customHooks';
import { Spinner } from 'styles/blocks/spinner';
import { STRINGS } from 'config';

const { PRODUCT: { PRIMARY_CARE, E_SPECIALIST } } = STRINGS;

// Variation of Select component that contains options that are displayed with primary and secondary emphasis.
// PrimaryOptions are displayed as regular select options, but SecondaryOptions are displayed with smaller button size and text.
export function SelectFlexible({ answer, index, isMounted, isClinicalReviewMode, onSelectOption, selected, showSpinner, product, secondary }) {
  const isFirst = index === 0;

  const buttonRef = useRef();
  useAutoFocus(isFirst, isMounted, buttonRef);

  const primaryCareOrESpecialist = product === PRIMARY_CARE || product === E_SPECIALIST;

  if (secondary) {
    return (
      <SelectOptionFlexible.SecondaryOption
        onClick={() => onSelectOption(answer)}
        aria-label={answer.text}
        ref={buttonRef}
        isClinicalReviewMode={isClinicalReviewMode}
        triageLevel={answer.triageLevel}
        selected={selected}
      >
        <SelectOptionFlexible.Container isClinicalReviewMode={isClinicalReviewMode}>
          <SelectOptionFlexible.Text>{answer.text}</SelectOptionFlexible.Text>
          {isClinicalReviewMode && primaryCareOrESpecialist && _map(answer.tags, tag => <SelectOptionFlexible.TaggedIcon tag={tag} />)}
          <SelectOptionFlexible.ClinicalReviewIcon triageLevel={isClinicalReviewMode && primaryCareOrESpecialist && answer.triageLevel} />
        </SelectOptionFlexible.Container>
        <SelectOptionFlexible.ClinicalReviewHelpText isClinicalReviewMode={isClinicalReviewMode}>{answer.answerId}</SelectOptionFlexible.ClinicalReviewHelpText>
        {answer.groupScore ? (
          <SelectOptionFlexible.GroupScoringText isClinicalReviewMode={isClinicalReviewMode}>groupScore: {answer.groupScore}</SelectOptionFlexible.GroupScoringText>
        ) : null}
        {primaryCareOrESpecialist && <Spinner isVisible={showSpinner} />}
      </SelectOptionFlexible.SecondaryOption>
    );
  }
  return (
    <SelectOptionFlexible.PrimaryOption
      onClick={() => onSelectOption(answer)}
      aria-label={answer.text}
      ref={buttonRef}
      isClinicalReviewMode={isClinicalReviewMode}
      triageLevel={answer.triageLevel}
      selected={selected}
      id={`${answer?.text?.toLowerCase()}Button-input${selected ? '-selected' : ''}`}
      data-automation={`${answer?.text?.toLowerCase()}Button-input${selected ? '-selected' : ''}`}
    >
      <SelectOptionFlexible.Container isClinicalReviewMode={isClinicalReviewMode}>
        <SelectOptionFlexible.Text>{answer.text}</SelectOptionFlexible.Text>
        {isClinicalReviewMode && primaryCareOrESpecialist && _map(answer.tags, tag => <SelectOptionFlexible.TaggedIcon tag={tag} />)}
        <SelectOptionFlexible.ClinicalReviewIcon triageLevel={isClinicalReviewMode && primaryCareOrESpecialist && answer.triageLevel} />
      </SelectOptionFlexible.Container>
      <SelectOptionFlexible.ClinicalReviewHelpText isClinicalReviewMode={isClinicalReviewMode}>{answer.answerId}</SelectOptionFlexible.ClinicalReviewHelpText>
      {answer.groupScore ? (
        <SelectOptionFlexible.GroupScoringText isClinicalReviewMode={isClinicalReviewMode}>groupScore: {answer.groupScore}</SelectOptionFlexible.GroupScoringText>
      ) : null}
      {primaryCareOrESpecialist && <Spinner isVisible={showSpinner} />}
    </SelectOptionFlexible.PrimaryOption>
  );
}
